export const category_type = ['category', 'subcategory', 'leaf']